import { render, staticRenderFns } from "./modalSeleccionarAvatar.vue?vue&type=template&id=5087cf11&scoped=true&"
import script from "./modalSeleccionarAvatar.vue?vue&type=script&lang=js&"
export * from "./modalSeleccionarAvatar.vue?vue&type=script&lang=js&"
import style0 from "./modalSeleccionarAvatar.vue?vue&type=style&index=0&id=5087cf11&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087cf11",
  null
  
)

export default component.exports